const LOCAL_KEYS = {
  AUTH_TOKEN: 'hp-auth',
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  EXPIRATION_TOKEN: 'expiration_token',
  LANGUAGE_TOKEN: 'i18nextLng',
};

type StorageType = typeof localStorage | typeof sessionStorage;

class Storage {
  method: StorageType;

  constructor(method: StorageType) {
    this.method = method;
  }

  set(key: string, value: unknown) {
    this.method.setItem(key, JSON.stringify(value));
  }

  get(key: string, defaultValue?: unknown) {
    const value = this.method.getItem(key);
    try {
      return value ? JSON.parse(value) : defaultValue;
    } catch (e) {
      return defaultValue;
    }
  }

  clear(key: string) {
    this.method.removeItem(key);
  }

  clearAll() {
    this.method.clear();
  }
}

const LocalStorage = new Storage(localStorage);
const SessionStorage = new Storage(sessionStorage);

export { LOCAL_KEYS, LocalStorage, SessionStorage };
